const DATE_LOCALE = 'fi-FI';

export { DATE_LOCALE };
